const apiMap = [
    { key: 'parallel-pos-uat.leaflogix.net', api: '/', printManifest: '//parallel-uat-rpt.azurewebsites.net' },
    { key: 'ascend-pos.leaflogix.net', api: '/', printManifest: '//ascend-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'atglive-pos.leaflogix.net', api: '/', printManifest: '//md-eastlive-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'bloom-medicinals-pos.leaflogix.net', api: '/', printManifest: '//bloom-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'bluegate-pos.leaflogix.net', api: '/', printManifest: '//bluegate-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'columbiacare-pos.leaflogix.net', api: '/', printManifest: '//md-live-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'cresco-pos.leaflogix.net', api: '/', printManifest: '//cresco-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'curaleaf-pos.leaflogix.net', api: '/', printManifest: '//curaleaf-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'gage-pos.leaflogix.net', api: '/', printManifest: '//gage-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'greendragon-pos.leaflogix.net', api: '/', printManifest: '//md-live-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'greengrowth-pos.leaflogix.net', api: '/', printManifest: '//greengrowth-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'gti-pos.leaflogix.net', api: '/', printManifest: '//gti-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'harvest-pos.leaflogix.net', api: '/', printManifest: '//harvestreports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'mng-pos.leaflogix.net', api: '/', printManifest: '//md-live-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'pioneer-pos.leaflogix.net', api: '/', printManifest: '//md-pioneer-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'planet13-pos.leaflogix.net', api: '/', printManifest: '//md-live-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'shango-pos.leaflogix.net', api: '/', printManifest: '//shango-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'verano-pos.leaflogix.net', api: '/', printManifest: '//verano-reports.azurewebsites.net/Manifest2.aspx?'},
    { key: 'westlive-pos.leaflogix.net', api: '/', printManifest: '//md-westlive-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'live-pos.leaflogix.net', api: '/', printManifest: '//md-live-rpt.azurewebsites.net/Manifest2.aspx?'}, //this must appear below 'westlive-pos', since live-pos is a substring of it
    { key: 'west-pos.leaflogix.net', api: '/', printManifest: '//md-westlive-rpt.azurewebsites.net/Manifest2.aspx?'},
    { key: 'windycity-pos.leaflogix.net', api: '/', printManifest: '//windycity-reports.azurewebsites.net/Manifest2.aspx?'},
];

export function getApiUrl (href = window.location.href) {
    const found = apiMap.find((api) => href.includes(api.key));
    if(found){
        return found;
    }
    return {api:'/', printManifest: ''};
}



// WEBPACK FOOTER //
// ./ui_src/app/utils/ApiUrls.js